/**
 * DEMO — inkoopprijzen (zonder btw) van de Medik8-factuur 26703371, 12 augustus 2026. Gekoppeld
 * op productnaam, want de factuur gebruikt eigen namen. Regels die niet in de webshop staan
 * (Pro-maten, Exo-PDRN, Press & Clear, …) zijn salongebruik of nog niet in de winkel.
 * "C-Tetra Advanced" staat hier als C-Tetra Luxe: Sarah bevestigt dat nog.
 */
export const invoiceCosts: { name: string; cents: number }[] = [
  { name: 'r-retinoate day night', cents: 8450 },
  { name: 'daily radiance vitamin c spf 30', cents: 3985 },
  { name: 'crystal retinal 1', cents: 2850 },
  { name: 'crystal retinal 3', cents: 3250 },
  { name: 'crystal retinal 6', cents: 4100 },
  { name: 'c tetra', cents: 2850 },
  { name: 'c tetra luxe', cents: 4295 },
  { name: 'surface radiance cleanse', cents: 1720 },
  { name: 'lipid balance cleansing oil', cents: 1795 },
  { name: 'daily refresh balancing toner', cents: 1450 },
  { name: 'advanced day total protect', cents: 3950 },
  { name: 'press clear', cents: 2360 },
]

/** "r-Retinoate Day & Night" → "r retinoate day night". */
export const normalizeName = (s: string) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
